import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default class Isometric extends Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        
        return (
            <div className="row" id="body">
                    
            <div className="col-12 mx-0 col-lg-10" id="content">

                <div className="row pt-4" id="ui_design">
                    <div className="col-12 col-sm-6">
                      <img id="iso1" width="100%" src={require('../../../Images/Daily_project/Isometric/Iso0.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-sm-6">
                      <img id="iso2" width="100%" src={require('../../../Images/Daily_project/Isometric/Iso2.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 pt-4">
                      <img id="iso0" width="100%" src={require('../../../Images/Daily_project/Isometric/Iso1.png')} alt="Case_studies_1" />
                    </div>
                </div>
            </div>
                    
            <div className="col-lg-2 d-none d-lg-block px-4 pt-4 h-25 sticky-top" id="sidebar" style={{top: "56px"}}>

                <p className="h4">Project</p>
                <p>
                  <AnchorLink href="#iso1" className="bullet">Light house</AnchorLink>
                  <br />
                  <AnchorLink href="#iso2" className="bullet">Car</AnchorLink>
                  <br />
                  <AnchorLink href="#iso0" className="bullet">Bridge</AnchorLink>
                </p>

                <div className="row pt-4 px-3">
                <p className="h4">TOOLS</p>

                <div className="col-12 px-2">
                  <div className="row">
                          <img width="25%" className="tools" src={require('../../../Images/Tools/ai.png')} alt="Case_studies_1" />
                  </div>
                </div>
                
              </div>

            </div>
                  
            </div>
    )
}
}